module.exports = __webpack_public_path__ + "static/CAP_logo_NEW-49c26e04487bcaaa29e5e371e2a9a061.png";